/*
Composable useShowDashboardNotifications handles the global state of showing
notification sidebar. The composable is used within the navigation controls.
*/
export const useShowDashboardModal = () => {
  const currentModalName = useState<string>('modalName', () => '')

  const setModalVisible = (modalName: string) => {
    currentModalName.value = modalName
  }

  const setModalHidden = () => {
    currentModalName.value = ''
  }

  return { currentModalName, setModalVisible, setModalHidden }
}
